<template>
    <div class="custom-select" v-for="filter in filters" :key="filter.Id">
        <input
            type="checkbox"
            class="checkbox"
            :id="`cb-filter-${filter.Id}`"
            :value="`${filter.Id}`"
            :checked="filter.Checked"
            @change="onChange(alias, filter)" />
        <label class="checkbox-label" :for="`cb-filter-${filter.Id}`">{{ filter.Name }}</label>
    </div>
</template>

<script setup lang="ts">
// Vue
import { watch, onMounted } from 'vue';
// Pinia
import { storeToRefs } from 'pinia';
// Store
import { useRidingschoolStore } from '../../apps/ridingschool/store/ridingschool.store';
// Model
import { ICheckboxType } from '../../apps/ridingschool/model/ridingschool.models';
// Composable
import { useSearchParamUpdate } from '../../composables/useSearchParamUpdate';

const props = defineProps<{
    alias: string;
    filters: ICheckboxType[];
}>();

const ridingschoolStore = useRidingschoolStore();

const { resetComponentState } = storeToRefs(ridingschoolStore);

function onChange(alias: string, filter: ICheckboxType) {
    filter.Checked = !filter.Checked;

    if (filter.Checked) {
        // add to search query
        createFilterQuery(alias, filter.Id);
    } else {
        removeFromFilterQuery(alias, filter.Id);
    }
}

function createFilterQuery(alias: string, id: string) {
    useSearchParamUpdate(ridingschoolStore, 'remove', 'page', '');

    if (ridingschoolStore.searchParams?.has(alias)) {
        // append value (id) to alias "ex. searchIn"
        const all = ridingschoolStore.searchParams.getAll(alias);
        all.push(id);
        useSearchParamUpdate(ridingschoolStore, 'update', alias, all.toString());
    } else {
        // This is a new alias, so set alias with id
        useSearchParamUpdate(ridingschoolStore, 'update', alias, id.toString());
    }
}

function removeFromFilterQuery(alias: string, id: string) {
    const all = ridingschoolStore.searchParams?.getAll(alias);

    if (all) {
        const set = new Set(all[0].split(','));
        set.delete(id);

        if (set.size !== 0) {
            removeSingleSearchParam(alias, set);
        } else {
            removeAllSearchParams(alias);
        }
    }
}

function removeSingleSearchParam(alias: string, set: Set<string>) {
    useSearchParamUpdate(ridingschoolStore, 'update', alias, [...set].join(','));
}

function removeAllSearchParams(alias: string) {
    useSearchParamUpdate(ridingschoolStore, 'remove', alias, '');
}

function handleCheckedState() {
    props.filters.forEach((filter) => {
        if (ridingschoolStore.searchParams?.get(props.alias)?.includes(filter.Id)) {
            filter.Checked = true;
        } else {
            filter.Checked = false;
        }
    });
}

watch(resetComponentState, (newState, oldState) => {
    handleCheckedState();
});
onMounted(() => {
    if (ridingschoolStore.searchParams?.get(props.alias) !== null) {
        handleCheckedState();
    }
});
</script>
